import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { BrowserView, isTablet, MobileView, isMobile } from 'react-device-detect'
import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'
import * as routes from 'core/routing/constants/index'
import wizardsShape from 'core/components/wizard/shapes'
import { FormattedMessage, injectIntl } from 'react-intl'
import styled from 'styled-components'
import img from 'assets/images'
import {
  Drawer,
  Row,
  Col,
  ButtonPrimary,
  ButtonGhost,
  ButtonLink,
  Modal,
  Radio
} from 'core/components/ui'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import LandingPageGuide from 'core/templates/LandingPageGuide'

import svg from 'assets/svg'
import SVG from 'core/components/svg'

import { greys, fontFamily, font, borderRadius } from 'assets/themes/theme-default'

import { tradeInShape } from '../shapes'
import ModalContentListVehicles from './modal-content-list-vehicles'
import RegistrationSearch from './registration-search'
import ManualSearch from './manual-search'
import useGetCar from '../../core/hooks/useGetCar'

const paddingCard = `30px`

const Card1 = styled.div`
  padding: 0 ${paddingCard} 24px ${paddingCard};
  box-shadow: none;

  h1,
  h2 {
    color: ${greys.dark1};
  }
`

const Card2 = styled(Card1)`
  h1,
  h2 {
    color: ${greys.dark1};
  }

  padding: 0 ${paddingCard} ${paddingCard} ${paddingCard};
`

const CardTitle1 = styled.h2`
  &&& {
    font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.normal.name},`}
      ${fontFamily.normal};
    text-align: center;
    margin-bottom: 10px;
  }
`

const ImgStyled = styled.img`
  &&& {
    max-width: 100%;
  }
`
const Bordered = styled.div`
  border-width: 1px 0 0 0;
  border-style: solid;
  border-color: ${greys.light2};
`

const RadioSwitch = styled(Radio.Group)`
  padding: ${isMobile ? '5px' : '5px 10px'};
  background-color: ${greys.light2};
  border-radius: 20px;
  width: 100%;
  overflow: ${isMobile ? 'hidden' : 'initial'};
  & > .ant-radio-button-wrapper {
    border-radius: 20px;
    height: ${isMobile ? '100%' : '30px'};
    line-height: ${isMobile ? 'auto' : '31px'};
    background: none;
    border: none;
    box-shadow: none !important;
    width: 50%;
    &.ant-radio-button-wrapper-checked {
      background-color: #fff;

      color: ${isMobile ? '#fff' : props => props.theme.colors.color1.bg};
      color: ${props => props.theme.colors.color1.bg};
    }
    &:not(.ant-radio-button-wrapper-checked) {
      color: ${greys.dark3};
    }
    &:before {
      background: none !important;
    }
  }
`
const SubTitleWrapper = styled.div`
  background: ${greys.light3};
  font-size: ${font.size.base};
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.italic.name},`}
    ${fontFamily.italic};
  line-height: ${isMobile && 'normal'};
  margin: ${isMobile ? '10px' : '0px auto 35px'};
  padding: ${isMobile ? '10px' : '15px'};
  border-radius: ${borderRadius.base};
  // text-align: center;
`
const TitleIconWrapper = styled.div`
  width: ${isMobile ? '20px' : '30px'};
  height: ${isMobile ? '20px' : '30px'};
  margin: 0 auto;
`
const TitleIcon2 = styled(SVG)`
  fill: ${props => props.theme.colors.color1.bg};
  vertical-align: middle;
`

// const ColCardOr = styled(Col)`
//   position: absolute;
//   z-index: 3;
//   margin-top: -30px;
//   margin-right: -27px;
// `

// const CardOr = styled.div`
//   text-transform: uppercase;
//   border-radius: 100px;
//   width: 60px;
//   height: 60px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   color: ${greys.dark2};
//   font-size: ${font.size.lgxxs};
//   background: ${greys.light4};
//   box-shadow: 0 0 0 5px ${greys.light3};
// `

const Vehicle = props => {
  const [registrationVehiculeSelected, setRegistrationVehiculeSelected] = useState(null)
  const [modalVisible, setModalVisible] = useState(false)
  const [isManual, setIsManual] = useState(false)
  const [modalVisibleManualSearch, setModalVisibleManualSearch] = useState(false)

  const [searchType, setsearchType] = useState(1)

  const {
    wizards,
    setWizards,
    history,
    setTradeIn,
    tradeIn,
    resetTradeIn,
    intl,
    configuration,
    setCarInformations,
    resetCarInformations
  } = props

  const { getCarInformation, car, error, loading, resetErrorAndCar } = useGetCar({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' })
  })

  const { filtersList } = tradeIn

  const { vehiclesList } = filtersList

  const { providerConfiguration, campaign } = configuration
  const { deactivatedMakes } = campaign

  const searchByNumberPlate = providerConfiguration.providerNumberplateId

  const aStepsActive = wizards[wizards.activeWizard]

  const deleteConfiguration = () => {
    const currentStepIndex = _.findIndex(aStepsActive, item => item.hash === routes.TRADEIN_VEHICLE)

    const extendedSteps = aStepsActive.map((item, index) => {
      if (index > currentStepIndex) {
        const extendedItem = { ...item, isActive: false }
        return extendedItem
      }
      return item
    })

    const extentedWizards = { ...wizards, aStepsTradeIn: extendedSteps }

    setWizards(extentedWizards)
    if (currentStepIndex === 0) resetTradeIn()
    else resetTradeIn(true)
  }

  const activateNextStep = () => {
    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.TRADEIN_VEHICLE) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })

    const extentedWizards = { ...wizards, aStepsTradeIn: extendedSteps }
    setWizards(extentedWizards)
    history.push(extendedStep.hash)
    window.scrollTo(0, 0)
  }

  const showModal = () => {
    setModalVisible(true)
  }

  const handleOk = () => {
    if (registrationVehiculeSelected) {
      const { vehicle } = tradeIn

      const extendedVehicle = {
        ...registrationVehiculeSelected,
        numberplate:
          vehicle && vehicle.search && vehicle.search.length !== 17
            ? vehicle.search.toUpperCase()
            : null
        /*price: 0,
        prices: {
          totalOptionsPrice: 0,
          totalServiceContractsPrice: 0,
          totalPaintPrice: 0,
          totalSaddleries: 0
        }*/
      }

      setTradeIn({
        ...tradeIn,
        vehicle: extendedVehicle
      })

      resetCarInformations()

      getCarInformation(
        {
          id: registrationVehiculeSelected.id,
          catalog: registrationVehiculeSelected.beginPrice || registrationVehiculeSelected.catalog
        },
        registrationVehiculeSelected.co2Emission
      )
    }
  }

  useEffect(() => {
    if (loading === false) {
      if (!car && !error) {
        return
      }

      if (car) {
        setCarInformations(car)
        setModalVisible(false)
        activateNextStep()
      }
    }
  }, [loading])

  useEffect(() => {
    if (modalVisible === false) {
      resetErrorAndCar()
    }
  }, [modalVisible])

  const handleChangeSearch = value => {
    setsearchType(value)
  }
  const handleCancel = () => {
    setModalVisible(false)
  }

  const handleChangeRegistrationVehiculeSelected = vehicleSelected => {
    setRegistrationVehiculeSelected(vehicleSelected)
  }

  const handleDisplayManual = () => {
    setIsManual(true)
  }

  useEffect(() => {
    const extendedStepsActive = aStepsActive.filter(step => step.hash === routes.TRADEIN_VEHICLE)
    const currentStep = extendedStepsActive[0]

    const { isActive } = currentStep

    if (!isActive) {
      history.push(routes.HOME)
    }

    deleteConfiguration()
  }, [])

  return (
    <>
      {props.configuration.campaign.tradeInConfig === 2 && <LandingPageGuide />}

      <MainContentWrapper>
        {' '}
        {!isTablet && (
          <MobileView>
            <Row type="flex" justify="center" gutter={15}>
              <Col lg={12} md={20} xs={24} style={{ textAlign: 'center', margin: '10px 0' }}>
                <FormattedMessage id="search_by" />
              </Col>
            </Row>
            <Row justify="center">
              <Col xs={24} style={{ textAlign: 'center' }}>
                <RadioSwitch
                  value={searchType}
                  onChange={e => handleChangeSearch(e.target.value)}
                  style={{ marginBottom: '20px' }}
                >
                  <Radio.Button value={1}>
                    <FormattedMessage id="stock-vehicle-detail-list-infos-registration" />
                  </Radio.Button>
                  <Radio.Button value={2}>
                    <FormattedMessage id="search_manually" />
                  </Radio.Button>
                </RadioSwitch>
              </Col>
            </Row>

            {searchType === 1 && (
              <>
                {searchByNumberPlate && (
                  <RegistrationSearch showModal={showModal} deactivatedMakes={deactivatedMakes} />
                )}
              </>
            )}
            {searchType === 2 && (
              <>
                <ManualSearch showModal={showModal} />
              </>
            )}
          </MobileView>
        )}
        <BrowserView>
          <>
            {searchByNumberPlate && (
              <>
                <Row type="flex" justify="center" gutter={15}>
                  <Col lg={12} md={20} xs={24}>
                    <Card1>
                      <CardTitle1>
                        <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card1-title-1" />{' '}
                        {searchByNumberPlate && (
                          <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card1-title-2" />
                        )}
                      </CardTitle1>
                      <RegistrationSearch
                        showModal={showModal}
                        deactivatedMakes={deactivatedMakes}
                        providerConfiguration={providerConfiguration}
                      />
                    </Card1>
                  </Col>
                  {/* <ColCardOr lg={2} xs={0}>
                <CardOr>
                  <FormattedMessage id="tradeIn-cta-or" />
                </CardOr>
              </ColCardOr> */}
                </Row>
                <Row type="flex" justify="center" gutter={15}>
                  <Col lg={12} md={20} xs={24}>
                    <Row type="flex" align="middle" justify="center" gutter={0}>
                      <Col span={11}>
                        <Bordered />
                      </Col>
                      <Col span={2} style={{ textAlign: 'center' }}>
                        <FormattedMessage id="tradeIn-cta-or" />
                      </Col>
                      <Col span={11}>
                        <Bordered />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {!isManual && (
                  <Row type="flex" justify="center" gutter={15} style={{ marginTop: '12px' }}>
                    <Col>
                      <ButtonLink
                        style={{ height: 'auto' }}
                        onClick={handleDisplayManual}
                        type="link"
                      >
                        <FormattedMessage id="research_manual" />
                      </ButtonLink>
                    </Col>
                  </Row>
                )}
              </>
            )}
            {(!searchByNumberPlate || isManual) && (
              <Row type="flex" justify="center" gutter={15} style={{ marginTop: '20px' }}>
                <Col lg={12} md={20} xs={24} style={{ marginBottom: '50px' }}>
                  <Card2>
                    <CardTitle1 style={{ paddingBottom: '20px' }}>
                      <FormattedMessage id="research_manual" />
                    </CardTitle1>

                    <SubTitleWrapper>
                      <Row type="flex" justify="center" gutter={13}>
                        <Col lg={3} xs={3}>
                          <TitleIconWrapper>
                            <TitleIcon2 svg={svg.lightBulb} />
                          </TitleIconWrapper>
                        </Col>
                        <Col lg={21} xs={21}>
                          <FormattedMessage id="tradeIn-vehicle-homeTradeIn-subtitle2" />
                          <div style={{ textAlign: 'left' }}>
                            <ButtonLink
                              style={{ height: 'auto' }}
                              type="link"
                              className="btn-link-info"
                              onClick={() => setModalVisibleManualSearch(true)}
                            >
                              <FormattedMessage id="tradeIn-vehicle-homeTradeIn-subtitle-button" />
                            </ButtonLink>
                          </div>
                        </Col>
                      </Row>
                    </SubTitleWrapper>
                    <ManualSearch showModal={showModal} />
                  </Card2>
                </Col>
              </Row>
            )}
          </>
        </BrowserView>
        {!isMobile ? (
          <>
            <Modal
              style={isMobile && { top: 20 }}
              width="700px"
              visible={modalVisible}
              onOk={handleOk}
              onCancel={handleCancel}
              footer={[
                <ButtonPrimary className="globaldealer-valid-modal" key="submit" onClick={handleOk}>
                  <FormattedMessage id="tradeIn-vehicle-homeTradeIn-modalListVehicle-buttonOk" />
                </ButtonPrimary>,
                <ButtonGhost
                  className="globaldealer-cancel-modal"
                  key="back"
                  onClick={handleCancel}
                >
                  <FormattedMessage id="tradeIn-vehicle-homeTradeIn-modalListVehicle-buttonCancel" />
                </ButtonGhost>
              ]}
              className="globaldealer-modal-vehicle-list"
              title={
                <span>
                  {intl.formatMessage({
                    id: 'tradeIn-vehicle-homeTradeIn-modalListVehicle-Title'
                  })}
                </span>
              }
            >
              <ModalContentListVehicles
                registrationVehiculeSelected={registrationVehiculeSelected}
                handleChangeRegistrationVehiculeSelected={vehicleSelected =>
                  handleChangeRegistrationVehiculeSelected(vehicleSelected)
                }
                vehiclesList={vehiclesList}
                error={error}
              />
            </Modal>
            <Modal
              title={intl.formatMessage({ id: 'tradeIn-vehicle-homeTradeIn-subtitle-button' })}
              visible={modalVisibleManualSearch}
              footer={null}
              onCancel={() => setModalVisibleManualSearch(false)}
            >
              <ImgStyled src={img.certificate} alt="certificate" />
            </Modal>
          </>
        ) : (
          <>
            <Drawer
              placement="bottom"
              height="400"
              width="700px"
              visible={modalVisible}
              onOk={handleOk}
              onClose={handleCancel}
              className="globaldealer-modal-vehicle-list"
              title={
                <span>
                  {intl.formatMessage({
                    id: 'tradeIn-vehicle-homeTradeIn-modalListVehicle-Title'
                  })}
                </span>
              }
            >
              <ModalContentListVehicles
                registrationVehiculeSelected={registrationVehiculeSelected}
                handleChangeRegistrationVehiculeSelected={vehicleSelected =>
                  handleChangeRegistrationVehiculeSelected(vehicleSelected)
                }
                vehiclesList={vehiclesList}
              />
              <Row>
                <Col span={12} align="right" type="flex">
                  <ButtonPrimary
                    className="globaldealer-valid-modal"
                    key="submit"
                    onClick={handleOk}
                    style={{ marginRight: '10px' }}
                  >
                    <FormattedMessage id="tradeIn-vehicle-homeTradeIn-modalListVehicle-buttonOk" />
                  </ButtonPrimary>
                </Col>
                <Col span={12} align="left">
                  <ButtonGhost
                    className="globaldealer-cancel-modal"
                    key="back"
                    onClick={handleCancel}
                    style={{ marginLeft: '10px' }}
                  >
                    <FormattedMessage id="tradeIn-vehicle-homeTradeIn-modalListVehicle-buttonCancel" />
                  </ButtonGhost>
                </Col>
              </Row>
            </Drawer>

            <Drawer
              placement="bottom"
              height="400"
              title={intl.formatMessage({ id: 'tradeIn-vehicle-homeTradeIn-subtitle-button' })}
              visible={modalVisibleManualSearch}
              footer={null}
              onClose={() => setModalVisibleManualSearch(false)}
            >
              <ImgStyled src={img.certificate} alt="certificate" />
            </Drawer>
          </>
        )}
      </MainContentWrapper>
    </>
  )
}

Vehicle.propTypes = {
  intl: PropTypes.shape().isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  wizards: wizardsShape.isRequired,
  setWizards: PropTypes.func.isRequired,
  setTradeIn: PropTypes.func.isRequired,
  resetTradeIn: PropTypes.func.isRequired,
  tradeIn: tradeInShape.isRequired,
  configuration: PropTypes.shape().isRequired
}

export default withRouter(injectIntl(Vehicle))
